<sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
  <sc-title>{{'step title' | translate: ['tmc.transport-attach-detach.dialog.step.title.select-trailer-swap-target',
    translationService.language]}}</sc-title>
  <sc-flex-fitting-content [vertical]="true">
    <sc-tmc-table [tableModel]="tableModel" #tmcTableComponent [hideFilter]="true"
      (selectionChanged)="onSelectionChanged($event)">
    </sc-tmc-table>
  </sc-flex-fitting-content>
</sc-flex>